var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$style.icon},[_vm._v(" "+_vm._s(_vm.fix ? '+' : '')+_vm._s(_vm.bonus)+_vm._s(_vm.flex ? '%' : '')+" "),_c('BonusIcon',{attrs:{"size":"20"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }